import { useState } from 'react';
import { NudosUploadDownloadButton } from '../../../../../../components/NudosComponents';
import {
  IlogisticServiceDetails,
  IlogisticServiceTrelloCardData,
  LOCATION_PLACE_TYPE
} from '../../../../../../types/services';
import { uploadLogisticServiceFile } from '../../../../utils/logisticServices.utils';
import { displayDocumentByPermission } from '../../../../utils/general.utils';
import { useHistory } from 'react-router-dom';
import './LogisticServiceDocuments.scss';

const LogisticServiceDocuments = ({
  logisticServiceData,
  updateDataCallback,
  documentsOnly,
}: {
  logisticServiceData: IlogisticServiceDetails;
  updateDataCallback: () => void;
  documentsOnly?: boolean;
}) => {
  const history = useHistory();

  const { id, statusName, destinationLocation, originLocation, manualQuote } = logisticServiceData;
  const { documentUrl, quoteDocumentUrl, deliveryDocumentUrl, receiptDocumentUrl } = logisticServiceData;
  const [loadingToolsStatusDocument, setLoadingToolsStatusDocument] = useState(false);
  const [loadingQuote, setLoadingQuote] = useState(false);
  const [loadingDeliveryDocument, setLoadingDeliveryDocument] = useState(false);
  const [loadingReceptionDocument, setLoadingReceptionDocument] = useState(false);

  const toolsOriginIsWarehouse = [LOCATION_PLACE_TYPE.NUDOS, LOCATION_PLACE_TYPE.DIAGNOSTIC].includes(
    (originLocation?.place || '') as LOCATION_PLACE_TYPE
  );
  const toolsDestinationIsWarehouse = [LOCATION_PLACE_TYPE.NUDOS, LOCATION_PLACE_TYPE.DIAGNOSTIC].includes(
    (destinationLocation?.place || '') as LOCATION_PLACE_TYPE
  );
  const missingAndRequiredDns = toolsDestinationIsWarehouse && statusName === 'entregado' && !documentUrl;
  const alertEmptyStyles = missingAndRequiredDns ? 'alertEmpty' : alert;
  const missingQuoteDocumentStyles = logisticServiceData?.quoteDocumentUrl ? '' : 'alertEmpty';

  const showToolsStatusDocument = toolsDestinationIsWarehouse;
  const showDeliveryDocument = !toolsOriginIsWarehouse;
  const showReceptionDocument = !toolsDestinationIsWarehouse;
  const billingCountryId = logisticServiceData?.billingCountry?.id;

  const uploadToolsStatusDocument = (documentFile?: File) =>
    uploadLogisticServiceFile({
      logisticServiceId: id,
      type: 'document',
      file: documentFile,
      handleLoading: setLoadingToolsStatusDocument,
      updateDataCallback: updateDataCallback,
      billingCountryId: Number(billingCountryId)
    });

  const uploadQuote = (quoteFile?: File) =>
    uploadLogisticServiceFile({
      logisticServiceId: id,
      type: 'quote',
      file: quoteFile,
      handleLoading: setLoadingQuote,
      updateDataCallback: updateDataCallback,
      billingCountryId: Number(billingCountryId)
    });

  const uploadDeliveryDocument = (deliveryFile?: File) =>
    uploadLogisticServiceFile({
      logisticServiceId: id,
      type: 'delivery',
      file: deliveryFile,
      handleLoading: setLoadingDeliveryDocument,
      updateDataCallback: updateDataCallback,
      billingCountryId: Number(billingCountryId)
    });

  const uploadReceptionDocument = (receptionFile?: File) =>
    uploadLogisticServiceFile({
      logisticServiceId: id,
      type: 'receipt',
      file: receptionFile,
      handleLoading: setLoadingReceptionDocument,
      updateDataCallback: updateDataCallback,
      billingCountryId: Number(billingCountryId)
    });

  return (
    <div className="LogisticServiceDocuments">
      {!documentsOnly && <div className="logisticServiceDetailsTab1SectionTitle">Documentos</div>}{' '}
      <div className="documentsContainer">
        {displayDocumentByPermission() && (
          <div className="relative">
            {manualQuote && <div className="customButton" onClick={() => history.push(`/logistic-service/edit/${id}`)} />}
            <NudosUploadDownloadButton
              customClassName={`LogisticServiceDocumentsUploadButton ${missingQuoteDocumentStyles}`}
              customWidth="127px"
              uploadedFileHandler={(file?: File) => uploadQuote(file)}
              currentFileUrl={quoteDocumentUrl || ''}
              downloadButtonText="Ver cotización"
              buttonEmptyText="Cotización"
              buttonFilledText="Cotización"
              isDisabled={true} // Se deshabilita la carga directa de la cotización
              showSkeletonLoader={loadingQuote}
              keepOwnFileState={false}
            />
          </div>
        )}
        {showToolsStatusDocument && (
          <NudosUploadDownloadButton
            customClassName={`LogisticServiceDocumentsUploadButton ${alertEmptyStyles}`}
            customWidth="127px"
            uploadedFileHandler={(file?: File) => uploadToolsStatusDocument(file)}
            currentFileUrl={documentUrl || ''}
            downloadButtonText="Ver estado del dispositivo"
            buttonEmptyText="Estado del dispositivo"
            buttonFilledText="Estado del dispositivo"
            isDisabled={loadingToolsStatusDocument}
            showSkeletonLoader={loadingToolsStatusDocument}
            keepOwnFileState={false}
          />
        )}
        {showDeliveryDocument && (
          <NudosUploadDownloadButton
            customClassName="LogisticServiceDocumentsUploadButton"
            customWidth="127px"
            uploadedFileHandler={(file?: File) => uploadDeliveryDocument(file)}
            currentFileUrl={deliveryDocumentUrl || ''}
            downloadButtonText="Ver documento de entrega"
            buttonEmptyText="Documento de entrega"
            buttonFilledText="Documento de entrega"
            isDisabled={loadingDeliveryDocument}
            showSkeletonLoader={loadingDeliveryDocument}
            keepOwnFileState={false}
          />
        )}
        {showReceptionDocument && (
          <NudosUploadDownloadButton
            customClassName="LogisticServiceDocumentsUploadButton"
            customWidth="127px"
            uploadedFileHandler={(file?: File) => uploadReceptionDocument(file)}
            currentFileUrl={receiptDocumentUrl || ''}
            downloadButtonText="Ver documento de recibido"
            buttonEmptyText="Documento de recibido"
            buttonFilledText="Documento de recibido"
            isDisabled={loadingReceptionDocument}
            showSkeletonLoader={loadingReceptionDocument}
            keepOwnFileState={false}
          />
        )}
      </div>
    </div>
  );
};

export default LogisticServiceDocuments;
